import React from "react";
import { useLocation } from "react-router-dom";
import { Spin } from "antd";
import LockedPage from "./LockedPage";
import { useAppPages } from "../../context/AppPageContext";

function RouteGuard({ children }) {
  const { pathname } = useLocation();
  const { isRouteEnabled, loading } = useAppPages();

  if (loading) {
    return <Spin fullscreen />;
  }

  if (!isRouteEnabled(pathname)) {
    return <LockedPage />;
  }

  return children;
}

export default RouteGuard;
